import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGOS } from "@/lib/company";
import { Button } from "@/components/ui/button";
import { LogOut, FileText, Library, IndianRupee } from "lucide-react";

export function AppHeader() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const links = [
    { to: "/", label: "Quotations", icon: FileText, match: (p) => p === "/" },
    { to: "/library", label: "Drawing Library", icon: Library, match: (p) => p.startsWith("/library") },
    { to: "/rates", label: "Rate Library", icon: IndianRupee, match: (p) => p.startsWith("/rates") },
  ];

  return (
    <header className="sticky top-0 z-30 bg-white/85 backdrop-blur-xl border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 md:px-8 h-16 flex items-center justify-between gap-4">
        <button onClick={() => navigate("/")} className="shrink-0" data-testid="brand-home">
          <img src={LOGOS.agi} alt="Artisan Guild Infra" className="h-8 w-auto" />
        </button>

        <nav className="hidden md:flex items-center gap-1 ml-4 flex-1">
          {links.map((l) => {
            const active = l.match(pathname);
            return (
              <button
                key={l.to}
                data-testid={`nav-${l.label.toLowerCase().replace(/ /g, "-")}`}
                onClick={() => navigate(l.to)}
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-sm text-sm transition-colors ${
                  active ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"
                }`}
              >
                <l.icon className="w-4 h-4" /> {l.label}
              </button>
            );
          })}
        </nav>

        <div className="flex items-center gap-3">
          <span className="hidden sm:block text-sm text-slate-500">{user?.email}</span>
          <Button
            variant="ghost"
            size="sm"
            data-testid="logout-button"
            onClick={logout}
            className="rounded-sm text-slate-600 hover:text-red-600"
          >
            <LogOut className="w-4 h-4 mr-1.5" /> Logout
          </Button>
        </div>
      </div>
    </header>
  );
}
